import { User } from "@/entities/user/user"
import { auth, db } from "@/firebase/firebase"
import { getDoc, doc } from "firebase/firestore"

export let cache_currentUser: User | undefined

export async function getCacheCurrentUser() {
   if (cache_currentUser) return cache_currentUser

   const authUser = auth.currentUser
   if (!authUser) return undefined

   const user = await getDoc(doc(db, "users", authUser.uid))
   if (!user.exists()) return undefined
   cache_currentUser = { id: user.id, ...user.data() } as User

   return cache_currentUser
}
